<mat-progress-bar mode="indeterminate" [class.show]="loading">
</mat-progress-bar>
<cdk-virtual-scroll-viewport [itemSize]="100" (scrolledIndexChange)="nextBatch($event)" class="list">
  <ng-container *cdkVirtualFor="let equipment of dataSource.allData">
    <sam-equipment-card [equipment]="equipment"></sam-equipment-card>
  </ng-container>
</cdk-virtual-scroll-viewport>